import React from 'react';
import { Route, IndexRoute } from 'react-router';
import CreateNewStationForm from './createNewStationForm';

export default (
  <Route path="create-new-station">
    <IndexRoute component={(props) => <CreateNewStationForm {...props} />} />
  </Route>
);
